import { __decorate, __metadata, __param } from 'tslib';
import { Component, EventEmitter, Output, Input, Directive, NgModule, ɵɵdefineInjectable, Injectable, ɵɵinject, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { FormGroup, ReactiveFormsModule, FormControl, Validators } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpRequest, HttpClient } from '@angular/common/http';
import { style, animate, AnimationBuilder } from '@angular/animations';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/common/http';
import * as ɵngcc4 from '@angular/animations';

function MiaDynamicFormComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "mia-element-builder", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r139 = ctx.$implicit;
    const ctx_r138 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", field_r139)("form", ctx_r138.form);
} }
function MiaElementBuilderComponent_label_1_strong_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "strong", 7);
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function MiaElementBuilderComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, MiaElementBuilderComponent_label_1_strong_2_Template, 2, 0, "strong", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r140 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("for", ctx_r140.field.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r140.field.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r140.field.required);
} }
function MiaElementBuilderComponent_mia_text_element_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mia-text-element", 8);
} if (rf & 2) {
    const ctx_r141 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r141.field)("form", ctx_r141.form);
} }
function MiaElementBuilderComponent_mia_select_element_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mia-select-element", 8);
} if (rf & 2) {
    const ctx_r142 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r142.field)("form", ctx_r142.form);
} }
function MiaElementBuilderComponent_mia_checkbox_element_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mia-checkbox-element", 8);
} if (rf & 2) {
    const ctx_r143 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r143.field)("form", ctx_r143.form);
} }
function MiaElementBuilderComponent_mia_radio_element_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mia-radio-element", 8);
} if (rf & 2) {
    const ctx_r144 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r144.field)("form", ctx_r144.form);
} }
function MiaElementBuilderComponent_mia_filezone_element_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mia-filezone-element", 8);
} if (rf & 2) {
    const ctx_r145 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r145.field)("form", ctx_r145.form);
} }
function MiaElementBuilderComponent_mia_button_element_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mia-button-element", 8);
} if (rf & 2) {
    const ctx_r146 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r146.field)("form", ctx_r146.form);
} }
function MiaElementBuilderComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r147 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r147.field.label, " is required");
} }
function MiaTextElementComponent_input_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 3);
} if (rf & 2) {
    const ctx_r149 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r149.field.name)("name", ctx_r149.field.name)("formControlName", ctx_r149.field.name);
    ɵngcc0.ɵɵattribute("type", ctx_r149.field.type);
} }
function MiaTextElementComponent_textarea_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "textarea", 4);
} if (rf & 2) {
    const ctx_r150 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("is-invalid", ctx_r150.isDirty && !ctx_r150.isValid);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r150.field.name)("id", ctx_r150.field.name)("placeholder", ctx_r150.field.placeholder);
} }
function MiaRadioElementComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelement(1, "input", 3);
    ɵngcc0.ɵɵelementStart(2, "label", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r152 = ctx.$implicit;
    const ctx_r151 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", opt_r152.key)("value", opt_r152.key)("formControlName", ctx_r151.field.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("for", opt_r152.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", opt_r152.label, " ");
} }
function MiaFilezoneElementComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r156 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "p", 4);
    ɵngcc0.ɵɵtext(2, " Drag a file here or ");
    ɵngcc0.ɵɵelementStart(3, "label", 5);
    ɵngcc0.ɵɵelementStart(4, "input", 6);
    ɵngcc0.ɵɵlistener("change", function MiaFilezoneElementComponent_div_1_Template_input_change_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r156); const ctx_r155 = ɵngcc0.ɵɵnextContext(); return ctx_r155.field.onUpload($event.target.files, ctx_r155.field); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(5, " browse ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, " to upload. ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r153 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r153.field.name);
} }
function MiaFilezoneElementComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelement(2, "img", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r154 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("src", ctx_r154.field.value, ɵngcc0.ɵɵsanitizeUrl);
} }
function MiaSelectElementComponent_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r158 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", opt_r158.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(opt_r158.label);
} }
function MiaCheckboxElementComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "label", 4);
    ɵngcc0.ɵɵelement(2, "input", 5);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r160 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formControlName", opt_r160.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", opt_r160.label, "");
} }
class ApiError {
}

class ApiResponse {
}

class ApiPagination {
}

class MIATableModel {
    constructor() {
        this.pageCurrent = 1;
        this.lastPage = 1;
        this.itemPerPage = 25;
        this.wheres = [];
        this.filters = {};
        this.search = '';
        this.ordType = { title: '', asc: 1 };
    }
    addWhere(key, value) {
        this.wheres[key] = value;
    }
    addwhereIn(key, values) {
        this.wheres[key + ':in'] = values;
    }
    addwhereNotIn(key, values) {
        this.wheres[key + ':notin'] = values;
    }
    addwhereLike(key, values) {
        this.wheres[key + ':like'] = values;
    }
    addwhereBetween(key, from, to) {
        this.wheres[key + ':between'] = from + ':' + to;
    }
    removeWhere(key) {
        let index = this.wheres.indexOf(key);
        if (index != -1) {
            this.wheres.splice(index, 1);
        }
    }
    getWhere() {
        let result = '';
        let isFirst = true;
        // tslint:disable-next-line:forin
        for (const key in this.wheres) {
            const value = this.wheres[key];
            if (!isFirst) {
                result += ';';
            }
            result += key + ':' + value;
            isFirst = false;
        }
        return result;
    }
    resetWhere() {
        this.wheres = [];
    }
    setPagination(lastPage, itemPerPage) {
        // Guardamos ultima pagina
        this.lastPage = lastPage;
        this.itemPerPage = itemPerPage;
    }
    toParams() {
        return {
            page: this.pageCurrent,
            where: this.getWhere(),
            search: this.search,
            ord: this.ordType.title,
            asc: this.ordType.asc,
            limit: this.itemPerPage
        };
    }
}

let CoreComponent = class CoreComponent {
    constructor() { }
    ngOnInit() {
    }
};
CoreComponent.ɵfac = function CoreComponent_Factory(t) { return new (t || CoreComponent)(); };
CoreComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CoreComponent, selectors: [["lib-core"]], decls: 2, vars: 0, template: function CoreComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, " core works! ");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
CoreComponent = __decorate([ __metadata("design:paramtypes", [])
], CoreComponent);

let MiaDynamicFormComponent = class MiaDynamicFormComponent {
    constructor() {
        this.onSend = new EventEmitter();
        this.fields = [];
    }
    ngOnInit() {
    }
};
MiaDynamicFormComponent.ɵfac = function MiaDynamicFormComponent_Factory(t) { return new (t || MiaDynamicFormComponent)(); };
MiaDynamicFormComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MiaDynamicFormComponent, selectors: [["mia-dynamic-form"]], inputs: { fields: "fields", form: "form" }, outputs: { onSend: "onSend" }, decls: 2, vars: 2, consts: [[1, "form-horizontal", 3, "formGroup", "ngSubmit"], [4, "ngFor", "ngForOf"], [3, "field", "form"]], template: function MiaDynamicFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵlistener("ngSubmit", function MiaDynamicFormComponent_Template_form_ngSubmit_0_listener() { return ctx.onSend.emit(ctx.form.value); });
        ɵngcc0.ɵɵtemplate(1, MiaDynamicFormComponent_div_1_Template, 2, 2, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.fields);
    } }, directives: function () { return [ɵngcc1.ɵangular_packages_forms_forms_y, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc2.NgForOf, MiaElementBuilderComponent]; }, styles: [""] });
__decorate([
    Output(),
    __metadata("design:type", Object)
], MiaDynamicFormComponent.prototype, "onSend", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], MiaDynamicFormComponent.prototype, "fields", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], MiaDynamicFormComponent.prototype, "form", void 0);
MiaDynamicFormComponent = __decorate([ __metadata("design:paramtypes", [])
], MiaDynamicFormComponent);

let MiaElementBuilderComponent = class MiaElementBuilderComponent {
    constructor() { }
    get isValid() { return this.form.controls[this.field.name].valid; }
    get isDirty() { return this.form.controls[this.field.name].dirty; }
    ngOnInit() {
    }
};
MiaElementBuilderComponent.ɵfac = function MiaElementBuilderComponent_Factory(t) { return new (t || MiaElementBuilderComponent)(); };
MiaElementBuilderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MiaElementBuilderComponent, selectors: [["mia-element-builder"]], inputs: { field: "field", form: "form" }, decls: 10, vars: 10, consts: [[1, "form-group", 3, "formGroup"], ["class", "form-control-label", 4, "ngIf"], [1, "", 3, "ngSwitch"], [3, "field", "form", 4, "ngSwitchCase"], ["class", "alert alert-danger my-1 p-2 fadeInDown animated", 4, "ngIf"], [1, "form-control-label"], ["class", "text-danger", 4, "ngIf"], [1, "text-danger"], [3, "field", "form"], [1, "alert", "alert-danger", "my-1", "p-2", "fadeInDown", "animated"]], template: function MiaElementBuilderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, MiaElementBuilderComponent_label_1_Template, 3, 3, "label", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, MiaElementBuilderComponent_mia_text_element_3_Template, 1, 2, "mia-text-element", 3);
        ɵngcc0.ɵɵtemplate(4, MiaElementBuilderComponent_mia_select_element_4_Template, 1, 2, "mia-select-element", 3);
        ɵngcc0.ɵɵtemplate(5, MiaElementBuilderComponent_mia_checkbox_element_5_Template, 1, 2, "mia-checkbox-element", 3);
        ɵngcc0.ɵɵtemplate(6, MiaElementBuilderComponent_mia_radio_element_6_Template, 1, 2, "mia-radio-element", 3);
        ɵngcc0.ɵɵtemplate(7, MiaElementBuilderComponent_mia_filezone_element_7_Template, 1, 2, "mia-filezone-element", 3);
        ɵngcc0.ɵɵtemplate(8, MiaElementBuilderComponent_mia_button_element_8_Template, 1, 2, "mia-button-element", 3);
        ɵngcc0.ɵɵtemplate(9, MiaElementBuilderComponent_div_9_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.field.type != "button");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.field.type);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "text");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "select");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "checkbox");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "radio");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "filezone");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "button");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isValid && ctx.isDirty);
    } }, directives: function () { return [ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc2.NgIf, ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase, MiaTextElementComponent,
        MiaSelectElementComponent,
        MiaCheckboxElementComponent,
        MiaRadioElementComponent,
        MiaFilezoneElementComponent,
        MiaButtonElementComponent]; }, styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], MiaElementBuilderComponent.prototype, "field", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], MiaElementBuilderComponent.prototype, "form", void 0);
MiaElementBuilderComponent = __decorate([ __metadata("design:paramtypes", [])
], MiaElementBuilderComponent);

let MiaTextElementComponent = class MiaTextElementComponent {
    constructor() {
        this.field = {};
    }
    get isValid() { return this.form.controls[this.field.name].valid; }
    get isDirty() { return this.form.controls[this.field.name].dirty; }
    ngOnInit() {
    }
};
MiaTextElementComponent.ɵfac = function MiaTextElementComponent_Factory(t) { return new (t || MiaTextElementComponent)(); };
MiaTextElementComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MiaTextElementComponent, selectors: [["mia-text-element"]], inputs: { field: "field", form: "form" }, decls: 3, vars: 3, consts: [[3, "formGroup"], ["class", "form-control", 3, "id", "name", "formControlName", 4, "ngIf"], ["rows", "9", "class", "form-control", 3, "is-invalid", "formControlName", "id", "placeholder", 4, "ngIf"], [1, "form-control", 3, "id", "name", "formControlName"], ["rows", "9", 1, "form-control", 3, "formControlName", "id", "placeholder"]], template: function MiaTextElementComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, MiaTextElementComponent_input_1_Template, 1, 4, "input", 1);
        ɵngcc0.ɵɵtemplate(2, MiaTextElementComponent_textarea_2_Template, 1, 5, "textarea", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.field.multiline);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.field.multiline);
    } }, directives: [ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc2.NgIf, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName], styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], MiaTextElementComponent.prototype, "field", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], MiaTextElementComponent.prototype, "form", void 0);
MiaTextElementComponent = __decorate([ __metadata("design:paramtypes", [])
], MiaTextElementComponent);

let MiaRadioElementComponent = class MiaRadioElementComponent {
    constructor() {
        this.field = {};
    }
    ngOnInit() {
    }
};
MiaRadioElementComponent.ɵfac = function MiaRadioElementComponent_Factory(t) { return new (t || MiaRadioElementComponent)(); };
MiaRadioElementComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MiaRadioElementComponent, selectors: [["mia-radio-element"]], inputs: { field: "field", form: "form" }, decls: 2, vars: 2, consts: [[3, "formGroup"], ["class", "form-check", 4, "ngFor", "ngForOf"], [1, "form-check"], ["type", "radio", 1, "form-check-input", 3, "id", "value", "formControlName"], [1, "form-check-label", 3, "for"]], template: function MiaRadioElementComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, MiaRadioElementComponent_div_1_Template, 4, 5, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.field.options);
    } }, directives: [ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc2.NgForOf, ɵngcc1.RadioControlValueAccessor, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName], styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], MiaRadioElementComponent.prototype, "field", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], MiaRadioElementComponent.prototype, "form", void 0);
MiaRadioElementComponent = __decorate([ __metadata("design:paramtypes", [])
], MiaRadioElementComponent);

let MiaFilezoneElementComponent = class MiaFilezoneElementComponent {
    constructor() {
        this.field = {};
    }
    get isValid() { return this.form.controls[this.field.name].valid; }
    get isDirty() { return this.form.controls[this.field.name].dirty; }
    ngOnInit() {
    }
    ngOnChange() {
        console.log(this.field.value);
        // this.field.value.
    }
};
MiaFilezoneElementComponent.ɵfac = function MiaFilezoneElementComponent_Factory(t) { return new (t || MiaFilezoneElementComponent)(); };
MiaFilezoneElementComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MiaFilezoneElementComponent, selectors: [["mia-filezone-element"]], inputs: { field: "field", form: "form" }, decls: 3, vars: 3, consts: [[3, "formGroup"], ["class", "drop-container dropzone", 4, "ngIf"], [4, "ngIf"], [1, "drop-container", "dropzone"], [1, "m-0"], [1, "upload-button"], ["type", "file", "multiple", "", 3, "formControlName", "change"], [1, "card"], [1, "card-img-top", 2, "max-height", "150px", "width", "150px", 3, "src"]], template: function MiaFilezoneElementComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, MiaFilezoneElementComponent_div_1_Template, 7, 1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, MiaFilezoneElementComponent_div_2_Template, 3, 1, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.field.value);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.field.value);
    } }, directives: [ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc2.NgIf, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName], styles: [".drop-container[_ngcontent-%COMP%]{background:#fff;border-radius:6px;height:150px;width:100%;box-shadow:1px 2px 20px hsla(0,0%,4%,.1);display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;border:2px dashed #c0c4c7}p[_ngcontent-%COMP%]{font-size:16px;font-weight:400;color:#c0c4c7}.upload-button[_ngcontent-%COMP%]{display:inline-block;border:none;outline:0;cursor:pointer;color:#5754a3}.upload-button[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{display:none}.dropzone[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;border-radius:5px;background:#fff;margin:10px 0}.dropzone.hovering[_ngcontent-%COMP%]{border:2px solid #f16624;color:#dadada!important}progress[_ngcontent-%COMP%]::-webkit-progress-value{-webkit-transition:width .1s;transition:width .1s}"] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], MiaFilezoneElementComponent.prototype, "field", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], MiaFilezoneElementComponent.prototype, "form", void 0);
MiaFilezoneElementComponent = __decorate([ __metadata("design:paramtypes", [])
], MiaFilezoneElementComponent);

let MiaSelectElementComponent = class MiaSelectElementComponent {
    constructor() {
        this.field = {};
    }
    ngOnInit() {
    }
};
MiaSelectElementComponent.ɵfac = function MiaSelectElementComponent_Factory(t) { return new (t || MiaSelectElementComponent)(); };
MiaSelectElementComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MiaSelectElementComponent, selectors: [["mia-select-element"]], inputs: { field: "field", form: "form" }, decls: 3, vars: 4, consts: [[3, "formGroup"], [1, "form-control", 3, "id", "formControlName"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function MiaSelectElementComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "select", 1);
        ɵngcc0.ɵɵtemplate(2, MiaSelectElementComponent_option_2_Template, 2, 2, "option", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.field.name)("formControlName", ctx.field.name);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.field.options);
    } }, directives: [ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.SelectControlValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName, ɵngcc2.NgForOf, ɵngcc1.NgSelectOption, ɵngcc1.ɵangular_packages_forms_forms_x], styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], MiaSelectElementComponent.prototype, "field", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], MiaSelectElementComponent.prototype, "form", void 0);
MiaSelectElementComponent = __decorate([ __metadata("design:paramtypes", [])
], MiaSelectElementComponent);

let MiaCheckboxElementComponent = class MiaCheckboxElementComponent {
    constructor() {
        this.field = {};
    }
    get isValid() { return this.form.controls[this.field.name].valid; }
    get isDirty() { return this.form.controls[this.field.name].dirty; }
    ngOnInit() {
    }
};
MiaCheckboxElementComponent.ɵfac = function MiaCheckboxElementComponent_Factory(t) { return new (t || MiaCheckboxElementComponent)(); };
MiaCheckboxElementComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MiaCheckboxElementComponent, selectors: [["mia-checkbox-element"]], inputs: { field: "field", form: "form" }, decls: 3, vars: 3, consts: [[3, "formGroup"], [3, "formGroupName"], ["class", "form-check form-check", 4, "ngFor", "ngForOf"], [1, "form-check", "form-check"], [1, "form-check-label"], ["type", "checkbox", "id", "inlineCheckbox1", "value", "option1", 1, "form-check-input", 3, "formControlName"]], template: function MiaCheckboxElementComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, MiaCheckboxElementComponent_div_2_Template, 4, 2, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formGroupName", ctx.field.name);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.field.options);
    } }, directives: [ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.FormGroupName, ɵngcc2.NgForOf, ɵngcc1.CheckboxControlValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName], styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], MiaCheckboxElementComponent.prototype, "field", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], MiaCheckboxElementComponent.prototype, "form", void 0);
MiaCheckboxElementComponent = __decorate([ __metadata("design:paramtypes", [])
], MiaCheckboxElementComponent);

let MiaBaseElementComponent = class MiaBaseElementComponent {
    constructor() {
        this.field = {};
    }
    get isValid() { return this.form.controls[this.field.name].valid; }
    get isDirty() { return this.form.controls[this.field.name].dirty; }
    ngOnInit() {
    }
};
MiaBaseElementComponent.ɵfac = function MiaBaseElementComponent_Factory(t) { return new (t || MiaBaseElementComponent)(); };
MiaBaseElementComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MiaBaseElementComponent, inputs: { field: "field", form: "form" } });
__decorate([
    Input(),
    __metadata("design:type", Object)
], MiaBaseElementComponent.prototype, "field", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], MiaBaseElementComponent.prototype, "form", void 0);
MiaBaseElementComponent = __decorate([ __metadata("design:paramtypes", [])
], MiaBaseElementComponent);

let MiaButtonElementComponent = class MiaButtonElementComponent extends MiaBaseElementComponent {
    constructor() {
        super();
    }
    ngOnInit() {
    }
};
MiaButtonElementComponent.ɵfac = function MiaButtonElementComponent_Factory(t) { return new (t || MiaButtonElementComponent)(); };
MiaButtonElementComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MiaButtonElementComponent, selectors: [["mia-button-element"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 3, consts: [[3, "formGroup"], ["type", "submit", 1, "btn", "btn-primary", 3, "disabled"]], template: function MiaButtonElementComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", !ctx.form.valid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.field.label);
    } }, directives: [ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective], styles: [""] });
MiaButtonElementComponent = __decorate([ __metadata("design:paramtypes", [])
], MiaButtonElementComponent);

let CoreModule = class CoreModule {
};
CoreModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CoreModule });
CoreModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CoreModule_Factory(t) { return new (t || CoreModule)(); }, imports: [[
            CommonModule,
            BrowserModule,
            ReactiveFormsModule
        ]] });

let MiaDynamicFormService = class MiaDynamicFormService {
    constructor() {
    }
    generateFormGroup(fields) {
        let fieldsCtrls = {};
        for (let f of fields) {
            if (f.type != 'checkbox') {
                fieldsCtrls[f.name] = f.required ? new FormControl(f.value || '', Validators.required)
                    : new FormControl(f.value || '');
            }
            else {
                let opts = {};
                for (let opt of f.options) {
                    opts[opt.key] = new FormControl(opt.value);
                }
                fieldsCtrls[f.name] = new FormGroup(opts);
            }
        }
        return new FormGroup(fieldsCtrls);
    }
};
MiaDynamicFormService.ɵfac = function MiaDynamicFormService_Factory(t) { return new (t || MiaDynamicFormService)(); };
MiaDynamicFormService.ɵprov = ɵɵdefineInjectable({ factory: function MiaDynamicFormService_Factory() { return new MiaDynamicFormService(); }, token: MiaDynamicFormService, providedIn: "root" });
MiaDynamicFormService = __decorate([ __metadata("design:paramtypes", [])
], MiaDynamicFormService);

let MiaFileService = class MiaFileService {
    //baseUrl = 'https://files.mobileia.com/api/upload';
    constructor(http) {
        this.http = http;
        this.baseUrl = 'http://0.0.0.0:8080/files/upload';
    }
    upload(app_id, files) {
        var formData = new FormData();
        formData.append('app_id', app_id);
        for (var i = 0; i < files.length; i++) {
            formData.append('file[' + i + ']', files[i]);
        }
        return this.http.post('https://files.mobileia.com/api/upload', formData);
    }
    uploadWithProgressByOne(app_id, file) {
        const formData = new FormData();
        formData.append('app_id', app_id);
        formData.append('file[0]', file);
        const req = new HttpRequest('POST', 'https://files.mobileia.com/api/upload', formData, {
            reportProgress: true,
        });
        return this.http.request(req);
    }
    uploadWithProgress(app_id, files) {
        var formData = new FormData();
        formData.append('app_id', app_id);
        for (var i = 0; i < files.length; i++) {
            formData.append('file[' + i + ']', files[i]);
        }
        const req = new HttpRequest('POST', 'https://files.mobileia.com/api/upload', formData, {
            reportProgress: true,
        });
        return this.http.request(req);
    }
};
MiaFileService.ɵfac = function MiaFileService_Factory(t) { return new (t || MiaFileService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient)); };
MiaFileService.ctorParameters = () => [
    { type: HttpClient }
];
MiaFileService.ɵprov = ɵɵdefineInjectable({ factory: function MiaFileService_Factory() { return new MiaFileService(ɵɵinject(HttpClient)); }, token: MiaFileService, providedIn: "root" });
MiaFileService = __decorate([ __metadata("design:paramtypes", [HttpClient])
], MiaFileService);

class MiaHttpService {
    constructor(http) {
        this._httpReference = http;
    }
    postArray(url, params) {
        return this._httpReference.post(url, params);
    }
    postObject(url, params) {
        return this._httpReference.post(url, params);
    }
    requestArray(url, params, callback) {
        this._httpReference.post(url, params).subscribe(data => {
            if (data.success) {
                callback(data.response);
            }
        });
    }
    requestObject(url, params, callback) {
        this._httpReference.post(url, params).subscribe(data => {
            if (data.success) {
                callback(data.response);
            }
        });
    }
}

let MiaSplashService = class MiaSplashService {
    constructor(animationBuilder, document) {
        this.animationBuilder = animationBuilder;
        this.document = document;
        // Get the splash screen element
        this.splashScreenEl = this.document.body.querySelector('#mia-splash-screen');
    }
    /**
       * Show the splash screen
       */
    show() {
        this.player =
            this.animationBuilder
                .build([
                style({
                    opacity: '0',
                    zIndex: '99999'
                }),
                animate('400ms ease', style({ opacity: '1' }))
            ]).create(this.splashScreenEl);
        setTimeout(() => {
            this.player.play();
        }, 0);
    }
    /**
     * Hide the splash screen
     */
    hide() {
        this.player =
            this.animationBuilder
                .build([
                style({ opacity: '1' }),
                animate('400ms ease', style({
                    opacity: '0',
                    zIndex: '-10'
                }))
            ]).create(this.splashScreenEl);
        setTimeout(() => {
            this.player.play();
        }, 0);
    }
};
MiaSplashService.ɵfac = function MiaSplashService_Factory(t) { return new (t || MiaSplashService)(ɵngcc0.ɵɵinject(ɵngcc4.AnimationBuilder), ɵngcc0.ɵɵinject(DOCUMENT)); };
MiaSplashService.ctorParameters = () => [
    { type: AnimationBuilder },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MiaSplashService.ɵprov = ɵɵdefineInjectable({ factory: function MiaSplashService_Factory() { return new MiaSplashService(ɵɵinject(AnimationBuilder), ɵɵinject(DOCUMENT)); }, token: MiaSplashService, providedIn: "root" });
MiaSplashService = __decorate([ __param(1, Inject(DOCUMENT)),
    __metadata("design:paramtypes", [AnimationBuilder, Object])
], MiaSplashService);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CoreComponent, [{
        type: Component,
        args: [{
                selector: 'lib-core',
                template: `
    <p>
      core works!
    </p>
  `
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MiaDynamicFormComponent, [{
        type: Component,
        args: [{
                selector: 'mia-dynamic-form',
                template: "<form (ngSubmit)=\"onSend.emit(this.form.value)\" [formGroup]=\"form\" class=\"form-horizontal\">\n    <div *ngFor=\"let field of fields\">\n        <mia-element-builder [field]=\"field\" [form]=\"form\"></mia-element-builder>\n    </div>\n    <!--<div class=\"form-row\"></div>\n    <div class=\"form-group\">\n        <button type=\"submit\" [disabled]=\"!form.valid\" class=\"btn btn-primary\">Save</button>\n    </div>-->\n</form>",
                styles: [""]
            }]
    }], function () { return []; }, { onSend: [{
            type: Output
        }], fields: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MiaElementBuilderComponent, [{
        type: Component,
        args: [{
                selector: 'mia-element-builder',
                template: "<div class=\"form-group\" [formGroup]=\"form\">\n    <label *ngIf=\"field.type != 'button'\" class=\"form-control-label\" [attr.for]=\"field.label\">\n        {{field.label}}\n        <strong class=\"text-danger\" *ngIf=\"field.required\">*</strong>\n    </label>\n    <div class=\"\" [ngSwitch]=\"field.type\">\n        <mia-text-element *ngSwitchCase=\"'text'\" [field]=\"field\" [form]=\"form\"></mia-text-element>\n        <mia-select-element *ngSwitchCase=\"'select'\" [field]=\"field\" [form]=\"form\"></mia-select-element>\n        <mia-checkbox-element *ngSwitchCase=\"'checkbox'\" [field]=\"field\" [form]=\"form\"></mia-checkbox-element>\n        <mia-radio-element *ngSwitchCase=\"'radio'\" [field]=\"field\" [form]=\"form\"></mia-radio-element>\n        <mia-filezone-element *ngSwitchCase=\"'filezone'\" [field]=\"field\" [form]=\"form\"></mia-filezone-element>\n        <mia-button-element *ngSwitchCase=\"'button'\" [field]=\"field\" [form]=\"form\"></mia-button-element>\n        <div class=\"alert alert-danger my-1 p-2 fadeInDown animated\" *ngIf=\"!isValid && isDirty\">{{field.label}} is required</div>\n    </div>\n</div>",
                styles: [""]
            }]
    }], function () { return []; }, { field: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MiaTextElementComponent, [{
        type: Component,
        args: [{
                selector: 'mia-text-element',
                template: "<div [formGroup]=\"form\">\n    <input *ngIf=\"!field.multiline\" [attr.type]=\"field.type\" class=\"form-control\" [id]=\"field.name\" [name]=\"field.name\" [formControlName]=\"field.name\">\n    <textarea *ngIf=\"field.multiline\" [class.is-invalid]=\"isDirty && !isValid\" [formControlName]=\"field.name\" [id]=\"field.name\" rows=\"9\" class=\"form-control\" [placeholder]=\"field.placeholder\"></textarea>\n</div>",
                styles: [""]
            }]
    }], function () { return []; }, { field: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MiaRadioElementComponent, [{
        type: Component,
        args: [{
                selector: 'mia-radio-element',
                template: "<div [formGroup]=\"form\">\n    <div class=\"form-check\" *ngFor=\"let opt of field.options\">\n        <input [id]=\"opt.key\" class=\"form-check-input\" type=\"radio\" [value]=\"opt.key\" [formControlName]=\"field.name\">\n        <label class=\"form-check-label\" for=\"{{ opt.key\u00A0}}\">\n      {{opt.label}}\n    </label>\n    </div>\n</div>",
                styles: [""]
            }]
    }], function () { return []; }, { field: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MiaFilezoneElementComponent, [{
        type: Component,
        args: [{
                selector: 'mia-filezone-element',
                template: "<div [formGroup]=\"form\">\n    <div *ngIf=\"!field.value\" class=\"drop-container dropzone\">\n        <p class=\"m-0\">\n            Drag a file here or\n            <label class=\"upload-button\">\n        <input type=\"file\" multiple=\"\" (change)=\"field.onUpload($event.target.files, field)\" [formControlName]=\"field.name\" /> browse\n      </label> to upload.\n        </p>\n    </div>\n    <div *ngIf=\"field.value\">\n        <!-- <button type=\"button\" class=\"btn btn-primary\">Change</button> -->\n        <div class=\"card\">\n            <img class=\"card-img-top\" [src]=\"field.value\" style=\"max-height: 150px; width: 150px;\">\n        </div>\n    </div>\n</div>",
                styles: [".drop-container{background:#fff;border-radius:6px;height:150px;width:100%;box-shadow:1px 2px 20px hsla(0,0%,4%,.1);display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;border:2px dashed #c0c4c7}p{font-size:16px;font-weight:400;color:#c0c4c7}.upload-button{display:inline-block;border:none;outline:0;cursor:pointer;color:#5754a3}.upload-button input{display:none}.dropzone{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;border-radius:5px;background:#fff;margin:10px 0}.dropzone.hovering{border:2px solid #f16624;color:#dadada!important}progress::-webkit-progress-value{-webkit-transition:width .1s;transition:width .1s}"]
            }]
    }], function () { return []; }, { field: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MiaSelectElementComponent, [{
        type: Component,
        args: [{
                selector: 'mia-select-element',
                template: "<div [formGroup]=\"form\">\n    <select class=\"form-control\" [id]=\"field.name\" [formControlName]=\"field.name\">\n    <option *ngFor=\"let opt of field.options\" [value]=\"opt.key\">{{opt.label}}</option>\n  </select>\n</div>",
                styles: [""]
            }]
    }], function () { return []; }, { field: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MiaCheckboxElementComponent, [{
        type: Component,
        args: [{
                selector: 'mia-checkbox-element',
                template: "<div [formGroup]=\"form\">\n    <div [formGroupName]=\"field.name\">\n        <div *ngFor=\"let opt of field.options\" class=\"form-check form-check\">\n            <label class=\"form-check-label\">\n       <input [formControlName]=\"opt.key\" class=\"form-check-input\" type=\"checkbox\" id=\"inlineCheckbox1\" value=\"option1\" />\n       {{opt.label}}</label>\n        </div>\n    </div>\n</div>",
                styles: [""]
            }]
    }], function () { return []; }, { field: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MiaBaseElementComponent, [{
        type: Directive
    }], function () { return []; }, { field: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MiaButtonElementComponent, [{
        type: Component,
        args: [{
                selector: 'mia-button-element',
                template: "<div [formGroup]=\"form\">\n    <button type=\"submit\" [disabled]=\"!form.valid\" class=\"btn btn-primary\">{{field.label}}</button>\n</div>",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CoreModule, { declarations: function () { return [CoreComponent,
        MiaDynamicFormComponent,
        MiaElementBuilderComponent,
        MiaTextElementComponent,
        MiaRadioElementComponent,
        MiaFilezoneElementComponent,
        MiaSelectElementComponent,
        MiaCheckboxElementComponent,
        MiaButtonElementComponent]; }, imports: function () { return [CommonModule,
        BrowserModule,
        ReactiveFormsModule]; }, exports: function () { return [MiaDynamicFormComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CoreModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BrowserModule,
                    ReactiveFormsModule
                ],
                declarations: [
                    CoreComponent,
                    MiaDynamicFormComponent,
                    MiaElementBuilderComponent,
                    MiaTextElementComponent,
                    MiaRadioElementComponent,
                    MiaFilezoneElementComponent,
                    MiaSelectElementComponent,
                    MiaCheckboxElementComponent,
                    MiaButtonElementComponent
                ],
                exports: [MiaDynamicFormComponent]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MiaDynamicFormService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MiaFileService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MiaSplashService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc4.AnimationBuilder }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

/*
 * Public API Surface of core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ApiError, ApiPagination, ApiResponse, CoreModule, MIATableModel, MiaDynamicFormComponent, MiaDynamicFormService, MiaFileService, MiaHttpService, MiaSplashService, CoreComponent as ɵa, MiaElementBuilderComponent as ɵb, MiaTextElementComponent as ɵc, MiaRadioElementComponent as ɵd, MiaFilezoneElementComponent as ɵe, MiaSelectElementComponent as ɵf, MiaCheckboxElementComponent as ɵg, MiaButtonElementComponent as ɵh, MiaBaseElementComponent as ɵi };

//# sourceMappingURL=mobileia-core.js.map